import React, { useState, useEffect } from 'react';
import App from './App';
import DashboardApp from './dasboardv3/App';
import ProtectedRoute from './ProtectedRoute';
import { parseRoute } from '../lib/navigation';

/**
 * AppRouter - Main router component for Bond Palantir
 *
 * Routes between:
 * - Palantir UI (App.js) - for bond management and debugging
 * - Dashboard V3 (dasboardv3/App.jsx) - for user and bond overview
 *
 * All routes are protected by authentication via ProtectedRoute component.
 *
 * Routing patterns:
 * - #/ or empty -> Dashboard search mode
 * - #/u/<user-id> -> Dashboard user view
 * - #/palantir/<bond-id> -> Palantir UI
 * - #cloud/livelog/<bond-id> -> Palantir UI (legacy)
 * - #mate -> Mate debug mode (Palantir UI)
 */
function AppRouter() {
    const [currentRoute, setCurrentRoute] = useState(() => parseRoute());

    useEffect(() => {
        // Parse initial route
        const initialRoute = parseRoute();
        setCurrentRoute(initialRoute);

        // Listen for hash changes (browser back/forward, manual navigation)
        const handleHashChange = () => {
            const newRoute = parseRoute();
            setCurrentRoute(newRoute);
        };

        window.addEventListener('hashchange', handleHashChange);

        return () => {
            window.removeEventListener('hashchange', handleHashChange);
        };
    }, []);

    // Wrap all routes with authentication protection
    return (
        <ProtectedRoute>
            {(currentRoute.type === 'palantir' || currentRoute.type === 'mate') ? (
                // Render Palantir UI for:
                // - #/palantir/<bond-id>
                // - Legacy routes like #cloud/livelog/<bond-id>
                // - #mate debug mode
                <App />
            ) : (
                // Render Dashboard V3 for:
                // - #/ or empty routes
                // - #/u/<user-id>
                <DashboardApp />
            )}
        </ProtectedRoute>
    );
}

export default AppRouter;
